// 앱 전역에서 공유하는 상수 및 매핑 정의
// 여러 페이지/컴포넌트에 흩어져 하드코딩되던 값들을 단일 출처로 통합한다.

// ===== 배송비 정책 =====
// CartPage / CheckoutPage 양쪽에 중복 하드코딩되던 값을 통합 (PAGE_IMPROVEMENTS 3번)
export const FREE_SHIPPING_THRESHOLD = 100000; // 10만원 이상 무료배송
export const SHIPPING_COST = 10000; // 미만 시 배송비

export const calculateShipping = (subtotal) =>
  subtotal >= FREE_SHIPPING_THRESHOLD || subtotal === 0 ? 0 : SHIPPING_COST;

// ===== 주문 상태 =====
// orders.json 의 orderStatus 값을 단일 기준으로 한다.
// (이전에는 formatters / OrderSearchPage / DashboardPage 가 제각각 다른 코드 체계를 사용했음 - 버그 B2)
export const ORDER_STATUS = {
  pending: { label: '주문 접수', badge: 'bg-blue-100 text-blue-800', step: 0 },
  preparing: { label: '상품 준비중', badge: 'bg-yellow-100 text-yellow-800', step: 1 },
  shipping: { label: '배송중', badge: 'bg-purple-100 text-purple-800', step: 2 },
  delivered: { label: '배송 완료', badge: 'bg-green-100 text-green-800', step: 3 },
  cancelled: { label: '주문 취소', badge: 'bg-red-100 text-red-800', step: -1 },
};

// 주문 진행 타임라인에 노출할 정상 흐름 단계
export const ORDER_TIMELINE = ['pending', 'preparing', 'shipping', 'delivered'];

export const getOrderStatusLabel = (status) =>
  ORDER_STATUS[status]?.label || status || '알 수 없음';

export const getOrderStatusBadgeClass = (status) =>
  ORDER_STATUS[status]?.badge || 'bg-gray-100 text-gray-800';

// ===== 결제 상태 =====
export const PAYMENT_STATUS = {
  pending: '결제 대기',
  completed: '결제 완료',
  cancelled: '결제 취소',
  refunded: '환불 완료',
};

export const getPaymentStatusLabel = (status) =>
  PAYMENT_STATUS[status] || status || '-';

// ===== 결제 수단 =====
export const PAYMENT_METHODS = {
  card: '신용카드',
  transfer: '계좌이체',
  cash: '무통장입금',
  kakao: '카카오페이',
};

export const getPaymentMethodLabel = (method) =>
  PAYMENT_METHODS[method] || method || '-';

// ===== 화환 카테고리 =====
export const WREATH_CATEGORIES = ['프리미엄', '스탠다드', '이코노미'];

// ===== 주문번호 =====
// 데이터/생성/검증 형식을 ORD-YYYYMMDD-NNN 으로 통일 (버그 B3)
export const ORDER_NO_PATTERN = /^ORD-\d{8}-\d{3}$/;

export const isValidOrderNo = (orderNo) =>
  typeof orderNo === 'string' && ORDER_NO_PATTERN.test(orderNo.trim());

// 신규 주문번호 생성: ORD-YYYYMMDD-{3자리 일련번호}
export const generateOrderNo = (date = new Date(), seq) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  // seq 미지정 시 시·분·초 기반으로 3자리 의사 일련번호 생성
  const fallbackSeq =
    (date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds()) % 1000;
  const seqStr = String(seq ?? fallbackSeq).padStart(3, '0');
  return `ORD-${yyyy}${mm}${dd}-${seqStr}`;
};

// ===== FAQ / 1:1 문의 공용 카테고리 =====
// FAQPage 와 InquiryForm 의 카테고리 용어 불일치를 해소 (PAGE_IMPROVEMENTS 4번)
export const SUPPORT_CATEGORIES = [
  '부고작성',
  '부고공유',
  '화환주문',
  '결제배송',
  '회원정보',
  '기타',
];
